module.exports = __webpack_public_path__ + "img/6.5e8f75d6.png";